module.exports = __webpack_public_path__ + "img/printer.1b895cb8.svg";